import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getGeneralDocumentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.dynamicList({ path: "GeneralDocument", ...action.payload }),
		);
		yield put({
			type: types.GET_GENERALDOCUMENT_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_GENERALDOCUMENT_ERROR,
			payload,
		});
	}
}

export function* getGeneralDocumentWatcherSaga() {
	yield takeLatest(types.GET_GENERALDOCUMENT_START, getGeneralDocumentHandlerSaga);
}

//create

//delete

function* deleteGeneralDocumentHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.delete,
			endPoint.deleteDyanamicItem("GeneralDocument", action.payload),
		);
		yield put({
			type: types.DELETE_GENERALDOCUMENT_SUCCESS,
			payload: data,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.DELETE_GENERALDOCUMENT_ERROR,
			payload,
		});
	}
}

export function* deleteGeneralDocumentWatcherSaga() {
	yield takeLatest(
		types.DELETE_GENERALDOCUMENT_START,
		deleteGeneralDocumentHandlerSaga,
	);
}

//update
